<template>
    <TrendsCard>
        <template #content>
            <PrismicRichText :field="testimonial" class="trends-testimonial-card__testimonial" />
        </template>
        <template #footer>
            <div class="trends-testimonial-card__author">
                <MktCardHandAdaptive v-if="image" brand-theme class="trends-testimonial-card__author-image-wrapper">
                    <PrismicImage v-if="image" :field="image" width="500" />
                </MktCardHandAdaptive>
                <div>
                    <div class="trends-testimonial-card__author-name">{{ name }}</div>
                    <div class="trends-testimonial-card__author-job-title">{{ jobTitle }}</div>
                </div>
            </div>
        </template>
    </TrendsCard>
</template>

<script setup lang="ts">
    import type {ImageField, RichTextField} from '@prismicio/client';
    import {PrismicImage, PrismicRichText} from '@prismicio/vue';
    import {MktCardHandAdaptive} from '#components';
    import TrendsCard from './TrendsCard.vue';

    defineProps<{
        testimonial?: RichTextField;
        name?: string;
        jobTitle?: string;
        image?: ImageField;
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .trends-testimonial-card {
        &__testimonial {
            :first-child {
                &:before {
                    content: '“';
                }
            }
            :last-child {
                &:after {
                    content: '”';
                }
            }
        }

        &__author {
            display: flex;
            flex-direction: column;
            margin-top: var(--joy-core-spacing-6);

            &-image-wrapper {
                $image-width: 53px;
                width: $image-width;
                min-width: $image-width;
                margin: 0 auto var(--joy-core-spacing-6) auto;
            }
            &-name {
                font-family: var(--joy-font-family-title);
            }
            &-job-title {
                @include text.getFontBySize(primary-400);
                font-weight: 400;
            }

            @include mq.screen_xs(min) {
                flex-direction: row;

                &-image-wrapper {
                    margin: 0 var(--joy-core-spacing-6) 0 0;
                }
            }
        }
    }
</style>
